import { Card } from '@/React/Shared/Component/Card'

export function BusinessNameGeneratorEmptySuggestionsCard() {
    return (
        <Card.Container>
            <Card.Content className="py-8 text-center">
                <p className="text-sm text-gray-500">
                    No business name suggestions available yet.
                </p>
            </Card.Content>
        </Card.Container>
    )
}
